// @ts-strict-ignore
import React, { useState, createContext, Dispatch, useContext, SetStateAction } from 'react'

export interface IFocusFadeGroupContext {
  focusedComponentID: string
  setFocusedComponentID: Dispatch<SetStateAction<string>>
}

const FocusFadeGroupContext = createContext<IFocusFadeGroupContext>({
  focusedComponentID: null,
  setFocusedComponentID: () => {},
})

export function useFocusFadeGroupContext() {
  return useContext(FocusFadeGroupContext)
}

export interface IFocusProviderProps {
  children: React.ReactNode
}

export function FocusFadeGroupProvider(props: IFocusProviderProps) {
  const { children } = props
  const [focusedComponentID, setFocusedComponentID] = useState<string>(null)

  return (
    <FocusFadeGroupContext.Provider value={{ focusedComponentID, setFocusedComponentID }}>
      {children}
    </FocusFadeGroupContext.Provider>
  )
}
